<template>
	<div>
		<div class="logo-area py-9">
			<v-img
				height="58"
				contain
				:src="
					`https://${keyword}.libnet.info/images/${keyword}/card-logo.png`
				"
			></v-img>
		</div>
		<div v-sticky class="search-header">
			<div class="search-form-holder">
				<div class="basket-area py-4 px-2">
					<span
						class="search-header-title display-1 font-weight-light"
						>{{ $t('reserve.title') }}</span
					>
				</div>
				<div class="search-form-header"></div>
				<v-form
					id="search-form"
					class="search-form elevation-9 pa-3 mx-auto"
				>
					<v-container grid-list-xs>
						<v-row>
							<v-col
								:cols="
									$vuetify.breakpoint.smAndUp
										? false
										: topRowSize
								"
								v-if="
									clientSettings.rooms_group_billing_enabled &&
										false
								"
							>
								<v-select
									attach="#search-form"
									outlined
									:hide-details="true"
									:items="userClasses"
									:label="$t('reserve.bookingTypeLabel')"
									item-text="name"
									item-value="id"
									v-model="userClassId"
									prepend-inner-icon="perm_identity"
									@change="setUserClass($event)"
								>
									<v-icon
										slot="prepend-inner"
										class="d-none d-sm-none d-md-flex"
										>perm_identity</v-icon
									>
								</v-select>
							</v-col>
							<v-col
								:cols="
									$vuetify.breakpoint.smAndUp
										? false
										: topRowSize
								"
								id="search-form-locations"
							>
								<v-select
									attach="#search-form"
									:menu-props="{
										fixed: true,
										nudgeRight: '24px',
										nudgeBottom: '92px'
									}"
									outlined
									:bottom="true"
									content-class="location-select-dropdown"
									:hide-details="true"
									:items="userClassLocations"
									:label="$t('reserve.locationLabel')"
									:no-data-text="$t('reserve.allLocations')"
									item-text="name"
									item-value="id"
									multiple
									v-model="selectedLocation"
								>
									<v-icon
										slot="prepend-inner"
										class="d-none d-sm-none d-md-flex"
										>location_on</v-icon
									>
									<template
										v-slot:selection="{ item, index }"
									>
										<span v-if="index === 0">
											<span
												class="text-no-wrap"
												v-if="
													selectedLocation.length ===
														userClassLocations.length
												"
												>{{
													$t(
														'reserve.viewAllLocations'
													)
												}}</span
											>
											<span
												class="text-no-wrap"
												v-else-if="
													selectedLocation.length ===
														1
												"
												>{{ item.name }}</span
											>
											<span v-else class="text-no-wrap">
												{{
													selectedLocation.length
												}}&nbsp;{{
													$t(
														'reserve.locationsSelected'
													)
												}}
											</span>
										</span>
									</template>

									<v-list-item
										slot="prepend-item"
										ripple
										@click="toggle"
									>
										<v-list-item-action>
											<v-icon
												:color="
													selectedLocation.length > 0
														? 'primary'
														: ''
												"
												>{{ icon }}</v-icon
											>
										</v-list-item-action>
										<v-list-item-title>{{
											$t('reserve.selectAll')
										}}</v-list-item-title>
									</v-list-item>
									<v-divider
										slot="prepend-item"
										class="mt-2"
									/>
								</v-select>
							</v-col>
							<v-col>
								<v-menu
									attach="#search-form"
									v-model="showDate"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											outlined
											:hide-details="true"
											v-model="formattedDate"
											append-icon="arrow_drop_down"
											:label="$t('reserve.date')"
											readonly
											v-on="on"
										>
											<v-icon
												slot="prepend-inner"
												class="d-none d-sm-none d-md-flex"
												>event</v-icon
											></v-text-field
										>
									</template>
									<v-date-picker
										v-model="selectedDate"
										no-title
										@input="showDate = false"
									>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col>
								<v-menu
									attach="#search-form"
									v-model="showTime"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
									:disabled="
										currentLocationOpenTime === null ||
											currentLocationCloseTime === null
									"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											outlined
											:hide-details="true"
											v-model="formattedTime"
											:label="$t('reserve.time')"
											append-icon="arrow_drop_down"
											readonly
											v-on="on"
											@click="setRange()"
										>
											<v-icon
												slot="prepend-inner"
												class="d-none d-sm-none d-md-flex"
												>watch_later</v-icon
											>
										</v-text-field>
									</template>
									<v-card>
										<div
											class="px-3 pt-3 d-flex justify-space-between align-center"
										>
											<div
												class="subtitle-2 font-weight-bold"
											>
												{{ formattedTime }}
											</div>
											<div class="caption" v-if="!allDay">
												({{ formattedTimeLength }})
											</div>
										</div>
										<v-card-text>
											<v-range-slider
												:hide-details="true"
												v-model="timeRange"
												:min="currentLocationOpenTime"
												:max="currentLocationCloseTime"
												step="900"
											></v-range-slider>
										</v-card-text>
										<div
											class="px-3 pb-3 d-flex justify-space-between align-center"
										>
											<div class="subtitle-2">
												{{ formattedStart }}
											</div>
											<v-btn
												text
												small
												@click="
													timeRange = [
														currentLocationOpenTime,
														currentLocationCloseTime
													]
												"
												>{{
													$t('reserve.viewAll')
												}}</v-btn
											>
											<div class="subtitle-2">
												{{ formattedEnd }}
											</div>
										</div>
									</v-card>
								</v-menu>
							</v-col>
							<v-col>
								<v-menu
									attach="#search-form"
									v-model="showCapacity"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									max-width="290px"
									min-width="290px"
								>
									<template v-slot:activator="{ on }">
										<v-text-field
											outlined
											:hide-details="true"
											v-model="formattedCapacity"
											:label="$t('reserve.capacity')"
											append-icon="arrow_drop_down"
											readonly
											v-on="on"
										>
											<v-icon
												slot="prepend-inner"
												class="d-none d-sm-none d-md-flex"
												>people_outline</v-icon
											>
										</v-text-field>
									</template>
									<v-card>
										<v-card-text>
											<v-btn
												class="my-3"
												@click="capacity = 0"
												block
												:outlined="capacity !== 0"
												:color="
													capacity === 0
														? 'primary'
														: ''
												"
												>{{
													$t('reserve.viewAll')
												}}</v-btn
											>
											<v-btn
												class="my-3"
												@click="capacity = 1"
												block
												:outlined="capacity !== 1"
												:color="
													capacity === 1
														? 'primary'
														: ''
												"
												>{{
													$t('reserve.2To10People')
												}}</v-btn
											>
											<v-btn
												class="my-3"
												@click="capacity = 2"
												block
												:outlined="capacity !== 2"
												:color="
													capacity === 2
														? 'primary'
														: ''
												"
												>{{
													$t('reserve.10To50People')
												}}</v-btn
											>
											<v-btn
												class="my-3"
												@click="capacity = 3"
												block
												:outlined="capacity !== 3"
												:color="
													capacity === 3
														? 'primary'
														: ''
												"
												>{{
													$t('reserve.50PlusPeople')
												}}</v-btn
											>
										</v-card-text>
									</v-card>
								</v-menu>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</div>
		</div>

		<co-location-rooms
			v-for="location in currentRoomsFilteredByLocation"
			:key="location.id"
			:location="location"
		>
		</co-location-rooms>
		<v-card
			class="mt-10 mx-auto no-match text-center"
			flat
			v-if="
				!currentRoomsFilteredByLocation ||
					currentRoomsFilteredByLocation.length === 0
			"
		>
			Sorry no rooms matching your criteria
		</v-card>
	</div>
</template>

<script>
import moment from 'moment';
import CoLocationRooms from '../components/location-rooms';
export default {
	components: {
		CoLocationRooms
	},
	data() {
		return {
			allDay: true,
			showDate: false,
			showTime: false,
			showCapacity: false,
			timeRange: [0, 0],
			capacity: 0,
			keyword: ''
		};
	},
	mounted() {
		Promise.all([
			this.$store.dispatch('fetchClientSettings'),
			this.$store.dispatch('fetchReserveLocations'),
			this.$store
				.dispatch('fetchOpeningHoursForDate', this.selectedDate)
				.then(() => this.setRange()),
			this.$store.dispatch('fetchUserClasses').then(() => {
				this.userClassId = this.userClasses.find(
					c => parseInt(c.type) === 1
				).id;
			})
		]).then(() => {
			if (this.selectedDate === null) {
				this.selectedDate = moment().format('YYYY-MM-DD');
			}
			this.selectedLocation = this.userClassLocations
				.slice()
				.map(r => r.id);
			// this.updateRooms();
		});
	},

	created() {
		this.keyword = window.config.keyword;
	},
	methods: {
		getLocationForId(id) {
			return this.$store.getters.userClassGetLocationForId(id);
		},
		getOpeningHoursForLocation(id) {
			return this.$store.getters.getOpeningHoursForLocationOnDate(
				id,
				this.selectedDate
			);
		},
		roomCapacity(room) {
			return Math.max(
				parseInt(room.capacity_standing),
				parseInt(room.capacity_chairs),
				parseInt(room.capacity_tables),
				room.layouts.reduce(
					(max, l) => Math.max(max, parseInt(l.capacity)),
					0
				)
			);
		},
		updateRooms() {
			this.$store.dispatch('fetchRoomsForLocationsOnDateForClass', {
				locations: this.selectedLocation,
				classId: this.userClassId,
				date: this.selectedDate
			});
		},
		toggle() {
			return this.$nextTick(() => {
				if (this.allLocations) {
					this.selectedLocation = [];
				} else {
					this.selectedLocation = this.userClassLocations
						.slice()
						.map(r => r.id);
				}
			});
		},
		setRange() {
			this.$nextTick(() => {
				if (
					this.timeRange[0] === 0 ||
					this.timeRange[0] === 0 ||
					this.allDay
				) {
					this.timeRange = [
						this.currentLocationOpenTime,
						this.currentLocationCloseTime
					];
				} else {
					const start = moment.unix(this.timeRange[0]);
					const end = moment.unix(this.timeRange[1]);
					const newStart = moment.unix(this.currentLocationOpenTime);
					const newEnd = moment.unix(this.currentLocationCloseTime);

					this.timeRange = [
						newStart
							.set({
								hour: start.get('hour'),
								minute: start.get('minute'),
								second: start.get('second')
							})
							.unix(),
						newEnd
							.set({
								hour: end.get('hour'),
								minute: end.get('minute'),
								second: end.get('second')
							})
							.unix()
					];
				}
			});
		},
		setUserClass(event) {
			this.$store.dispatch('setUserClass', event).then(() => {
				this.selectedLocation = this.userClassLocations
					.map(r => r.id)
					.filter(id => this.selectedLocation.includes(id));
				if (
					this.selectedLocation.length > 0 &&
					this.userClassId &&
					this.selectedDate
				) {
					this.updateRooms();
				}
			});
		}
	},
	watch: {
		timeRange: {
			deep: true,
			handler: function(val) {
				this.allDay =
					val[0] == this.currentLocationOpenTime &&
					val[1] == this.currentLocationCloseTime;
			}
		},
		selectedLocation: {
			deep: true,
			handler: function() {
				if (
					this.selectedLocation.length > 0 &&
					this.userClassId &&
					this.selectedDate
				) {
					this.updateRooms();
				}
			}
		},
		selectedDate: {
			// don't use arrow functions for watch
			handler: function() {
				this.setRange();
				if (
					this.selectedLocation.length > 0 &&
					this.userClassId &&
					this.selectedDate
				) {
					this.updateRooms();
				}
			}
		}
	},
	computed: {
		topRowSize() {
			return this.clientSettings.rooms_group_billing_enabled ? 6 : 12;
		},
		allLocations() {
			return (
				this.selectedLocation.length === this.userClassLocations.length
			);
		},
		someLocations() {
			return this.selectedLocation.length > 0 && !this.allLocations;
		},
		currentRooms() {
			return this.$store.state.currentRooms;
		},
		maxCapacity() {
			return this.$store.state.currentRooms.reduce((max, r) => {
				return Math.max(max, this.roomCapacity(r));
			}, 0);
		},
		currentRoomsFilteredByLocation() {
			return this.currentRoomsFiltered
				.reduce((locations, room) => {
					room.roomCapacity = this.roomCapacity(room);
					let location = locations.find(
						l => l.id === parseInt(room.location_id)
					);
					if (!location) {
						location = {
							id: parseInt(room.location_id),
							details: this.$store.getters.userClassGetLocationForId(
								room.location_id
							),
							rooms: []
						};
						locations.push(location);
					}
					location.rooms.push(room);
					return locations;
				}, [])
				.sort((a, b) => a.details.name.localeCompare(b.details.name));
		},
		currentRoomsFiltered() {
			if (!this.$store.state.currentRooms) return []; //TODO: how can this every be undefined?
			return (
				this.$store.state.currentRooms
					//filter non viewable
					.filter(r => r.restrictions.viewable)
					//filter for capacity
					.filter(r => {
						const capacity = this.roomCapacity(r);
						switch (this.capacity) {
							case 1:
								if (capacity > 10) return false;
								break;
							case 2:
								if (capacity < 10 || capacity > 50)
									return false;
								break;
							case 3:
								if (capacity < 50) return false;
								break;
							default:
								return true;
						}
						return true;
					})
					//filter closed
					.filter(r => {
						const hours = this.getOpeningHoursForLocation(
							r.location_id
						);
						return (
							this.allDay ||
							(hours.open <= this.timeRange[0] &&
								hours.close >= this.timeRange[1])
						);
					})
					//filter filter booked
					.filter(r =>
						r.bookings.reduce((show, b) => {
							if (this.allDay) return true; //TODO: clean this up, all day does not need to reduce
							const start = moment(b.start_time).unix();
							const end = moment(b.end_time).unix();
							if (
								(start > this.timeRange[0] &&
									start < this.timeRange[1]) ||
								(end > this.timeRange[0] &&
									end < this.timeRange[1])
							) {
								show = false;
							}
							return show;
						}, true)
					)
			);
		},
		icon() {
			if (this.allLocations) return 'check_box';
			if (this.someLocations) return 'indeterminate_check_box';
			return 'check_box_outline_blank';
		},
		currentLocationHoursOnDate() {
			return this.$store.getters.getMaxOpeningHoursForLocationsOnDate(
				this.selectedLocation,
				this.selectedDate
			);
		},
		currentLocationOpenTime() {
			return this.currentLocationHoursOnDate
				? this.currentLocationHoursOnDate.open
				: null;
		},
		currentLocationCloseTime() {
			return this.currentLocationHoursOnDate
				? this.currentLocationHoursOnDate.close
				: null;
		},
		formattedCapacity() {
			switch (this.capacity) {
				case 0:
					return this.$vuetify.breakpoint.smAndUp
						? this.$t('reserve.viewAll')
						: this.$t('reserve.viewAllShort');
				case 1:
					return this.$t('reserve.2To10People');
				case 2:
					return this.$t('reserve.10To50People');
				case 3:
					return this.$t('reserve.50PlusPeople');
				default:
					return this.$t('unknown');
			}
		},
		formattedStart() {
			return this.timeRange[0] > 0
				? moment.unix(this.timeRange[0]).format('h:mm:A')
				: '';
		},
		formattedEnd() {
			return this.timeRange[1] > 0
				? moment.unix(this.timeRange[1]).format('h:mm:A')
				: '';
		},
		formattedTime() {
			const all = this.$vuetify.breakpoint.smAndUp
				? this.$t('reserve.viewAll')
				: this.$t('reserve.viewAllShort');
			return this.allDay
				? all
				: `${this.formattedStart} - ${this.formattedEnd}`;
		},
		formattedTimeLength() {
			const start = moment.unix(this.timeRange[0]);
			const end = moment.unix(this.timeRange[1]);
			const d = moment.duration(end.diff(start));
			const hours = d.hours();
			const minutes = d.minutes();
			return hours > 0 ? `${hours}hr ${minutes}mins` : `${minutes}mins`;
		},
		formattedDate() {
			const format = this.$vuetify.breakpoint.smAndUp
				? 'D MMM YYYY'
				: 'D MMM';
			return this.selectedDate
				? moment(this.selectedDate).format(format)
				: '';
		},
		clientSettings() {
			return this.$store.state.clientSettings;
		},
		userClasses() {
			return this.$store.state.userClasses.filter(
				c => parseInt(c.type) > 0
			);
		},
		userClassLocations() {
			return this.$store.state.userClassLocations;
		},
		selectedLocation: {
			get() {
				return this.$store.state.selectedLocation;
			},
			set(value) {
				this.$store.commit('selectedLocation', value);
				this.setRange();
			}
		},
		selectedDate: {
			get() {
				return this.$store.state.selectedDate;
			},
			set(value) {
				this.$store
					.dispatch('fetchOpeningHoursForDate', value)
					.then(() => this.$store.commit('selectedDate', value));
			}
		},
		userClassId: {
			get() {
				return this.$store.state.userClassId;
			},
			set(value) {
				this.$store.commit('userClassId', value);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
#search-form-locations {
	position: relative;
}
.search-form-holder {
	position: relative;
	z-index: 2;
}
.search-form,
.no-match {
	max-width: 900px;
	background-color: #ffffff;
	position: relative;
}
.search-form-header {
	background-color: var(--header-color-1);
	height: 100px;
	position: absolute;
	top: 50;
	width: 100%;
}
.logo-area {
	background-color: var(--header-color-2);
}
.basket-area {
	background-color: var(--header-color-1);
	color: var(--header-color-3);
}
</style>
<style lang="scss">
#search-form .v-text-field .v-input__prepend-inner {
	// display: none;
}
</style>
